// UUID 생성 유틸리티 (브라우저 호환성 보장)
export function generateId(): string {
    // crypto.randomUUID가 지원되면 사용
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }

    // fallback: 수동 UUID v4 생성
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
